interface Ledger {
  ledger: string;
  _id: string;
}

interface Benefit {
  ledger: Ledger;
  remark?: string;
  amount: number;
  date: string;
  month: string;
  year: string;
  createdAt: string;
  updatedAt: string;
  _id: string;
  __v: number;
}

function useSearchBenefit(allBenefits: Benefit[], searchTerm: string, filteredBenefits: string | null) {
  const filterBySearchTerm = allBenefits
    ?.filter((benefit: Benefit) => {
      const matchesSearch =
        benefit?.ledger?.ledger
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        benefit.remark?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        benefit.amount.toString().includes(searchTerm);

      const matchesCategory =
        !filteredBenefits || benefit.ledger._id === filteredBenefits;

      return matchesSearch && matchesCategory;
    })
    .reverse();

  return { filterBySearchTerm };
}

export default useSearchBenefit;
